import { useEffect, useState } from 'react';

import consumer from '../../channels/consumer';

export default (channel, userId, processosAnos) => {
  const [connected, setConnected]       = useState(false);
  const [disconnected, setDisconnected] = useState(false);
  const [received, setReceived]         = useState(null);

  useEffect(() => {
    if (processosAnos?.length > 0) {
      consumer.subscriptions.create({channel, user_id: userId, processos_anos: processosAnos}, {
        connected:    () => setDisconnected(false) && setConnected(true),
        disconnected: () => setConnected(false) && setDisconnected(true),
        received:     (data) => setReceived(data)
      });
    }
  }, [channel, userId, processosAnos]);

  return {connected, disconnected, received};
};
